import { render, staticRenderFns } from "./ProcessOverview.vue?vue&type=template&id=bbaa64ec"
import script from "./ProcessOverview.vue?vue&type=script&lang=js"
export * from "./ProcessOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports